import { render, staticRenderFns } from "./Ding.vue?vue&type=template&id=73213300&scoped=true&"
import script from "./Ding.vue?vue&type=script&lang=js&"
export * from "./Ding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73213300",
  null
  
)

export default component.exports